import { useCallback } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';

import { systemInfoFetchPendingState, systemInformationState } from '@mo-recoil/system/atom';
import {
  getIsMultimall,
  getLunchTime,
  getOperationTime,
  getIsEventMall,
  getIsMarketingUse,
  getDisplayPointName,
  getIsCartUse,
  getIsPriceOpen,
  getIsPointUse,
  getIsCouponMenuUse,
  getSiteNumber,
  getIsNoMemberUseYn,
  getPriceFormat,
  getPriceFormatPerKrw,
} from '@mo-recoil/system/selector';
import commonApi from '../../apis/common/commonApi';

const useSiteInfo = () => {
  const [isPending, setIsPending] = useRecoilState(systemInfoFetchPendingState);
  const [systemInformation, setSystemInformation] = useRecoilState(systemInformationState);

  const getSystemInformationByKey = useCallback((key) => systemInformation[key], [systemInformation]);

  const operationTime = useRecoilValue(getOperationTime);
  const lunchTime = useRecoilValue(getLunchTime);
  const isMultimall = useRecoilValue(getIsMultimall);
  const isEventMall = useRecoilValue(getIsEventMall);
  const isMarketingUse = useRecoilValue(getIsMarketingUse);
  const displayPointName = useRecoilValue(getDisplayPointName);
  const isCartUse = useRecoilValue(getIsCartUse);
  const isPriceOpen = useRecoilValue(getIsPriceOpen);
  const isPointUse = useRecoilValue(getIsPointUse);
  const isCouponMenuUse = useRecoilValue(getIsCouponMenuUse);
  const priceFormat = useRecoilValue(getPriceFormat); // 원 or 마일리지 등등 가격단위
  const priceFormatPerKrw = useRecoilValue(getPriceFormatPerKrw); // 가격단위 환산 비율 (1가격단위 = n원)
  const siteNumber = useRecoilValue(getSiteNumber);
  const isNoMemberUseYn = useRecoilValue(getIsNoMemberUseYn);

  async function fetch() {
    setIsPending(true);

    const { result } = await commonApi.getSiteInformation();
    setSystemInformation(result);

    setIsPending(false);

    return result;
  }

  return {
    isPending,
    fetch,
    systemInformation,
    operationTime,
    lunchTime,
    isMultimall,
    isEventMall,
    isMarketingUse,
    displayPointName,
    isCartUse,
    isPriceOpen,
    isPointUse,
    isCouponMenuUse,
    getSystemInformationByKey,
    setSystemInformation,
    siteNumber,
    isNoMemberUseYn,
    priceFormat,
    priceFormatPerKrw,
  };
};

export default useSiteInfo;
